import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef, sizes } from '@shared/port-v1.0.0'

export type Props = BaseReactProps & {
	sizePresets: string
	sizeUnits: string
	position: 'top' | 'right' | 'bottom' | 'left'
	drawerOpacity: number
	drawerBlur: number
	header: boolean
	title: string
	titleOrder: string
	closeAction: boolean
}

import Comp from '../component'

export default {
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({ name: 'open', displayName: 'Open', group: 'Signals', type: 'signal' }),
			getPortDef({ name: 'close', displayName: 'Close', group: 'Signals', type: 'signal' }),

			getPortDef({
				name: 'position',
				displayName: 'Position',
				group: 'Custom',
				customGroup: 'Position',
				type: [
					{ label: 'Left', value: 'left' },
					{ label: 'Right', value: 'right' },
					{ label: 'Top', value: 'top' },
					{ label: 'Bottom', value: 'bottom' },
				],
				default: 'right',
			}),

			getPortDef({ name: 'sizePresets', displayName: 'Size', group: 'Dimensions', type: sizes, default: 'sm' }),
			getPortDef({
				name: 'sizeUnits',
				displayName: 'Size units',
				group: 'Dimensions',
				type: 'string',
				default: '',
				tooltip: '100vw, 100%, 500px, 20rem, auto',
			}),

			getPortDef({
				name: 'trapFocus',
				displayName: 'Trap focus',
				group: 'Params',
				type: 'boolean',
				default: true,
			}),
			getPortDef({
				name: 'returnFocus',
				displayName: 'Return focus',
				group: 'Params',
				type: 'boolean',
				default: true,
			}),
			getPortDef({
				name: 'closeOnEscape',
				displayName: 'Close on escape',
				group: 'Params',
				type: 'boolean',
				default: false,
			}),
			getPortDef({
				name: 'closeOnClickOutside',
				displayName: 'Close on click outside',
				group: 'Params',
				type: 'boolean',
				default: false,
			}),

			getPortDef({
				name: 'drawerOpacity',
				displayName: 'Opacity',
				group: 'Styles',
				type: 'number',
				default: 0.6,
			}),
			getPortDef({
				name: 'drawerBlur',
				displayName: 'Blur',
				group: 'Styles',
				type: 'number',
				default: 2,
			}),

			getPortDef({
				name: 'header',
				displayName: 'Header',
				group: 'Custom',
				customGroup: 'Header',
				type: 'boolean',
				default: false,
			}),
			getPortDef({
				name: 'title',
				displayName: 'Title',
				group: 'Custom',
				customGroup: 'Header',
				type: 'string',
				dependsOn: (p: Props) => p.header,
			}),
			getPortDef({
				name: 'titleOrder',
				displayName: 'Title Order',
				group: 'Custom',
				customGroup: 'Header',
				type: [
					{ label: 'H1', value: '1' },
					{ label: 'H2', value: '2' },
					{ label: 'H3', value: '3' },
					{ label: 'H4', value: '4' },
					{ label: 'H5', value: '5' },
					{ label: 'H6', value: '6' },
				],
				default: '3',
				dependsOn: (p: Props) => p.header,
			}),
			getPortDef({
				name: 'closeAction',
				displayName: 'Close action',
				group: 'Custom',
				customGroup: 'Header',
				type: 'boolean',
				default: false,
				dependsOn: (p: Props) => p.header,
			}),
		],

		outputs: [getPortDef({ name: 'closed', displayName: 'Сlosed', group: 'Signals', type: 'signal' })],
	},
} satisfies ReactNodeDef
